import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../config/axios';
import { floatingAdminRef } from '../components/FloatingAdmin';

export const useMembershipActivation = () => {
  const navigate = useNavigate();
  const [availableMemberships, setAvailableMemberships] = useState([]);
  const [membershipSelectionOpen, setMembershipSelectionOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAvailableMemberships = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.get('/api/membership-list', {
        params: { status: 'published' }
      });
      
      const now = new Date();
      const available = response.data.data.filter(membership => 
        new Date(membership.endDate) > now
      );
      
      setAvailableMemberships(available);
    } catch (error) {
      setError('Errore nel caricamento dei tesseramenti disponibili');
      console.error('Error fetching available memberships:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMembershipButtonClick = () => {
    setMembershipSelectionOpen(true);
  };

  const handleMembershipConfirmation = (membership) => {
    setMembershipSelectionOpen(false);
    
    if (!membership) {
      console.error('No membership selected');
      return;
    }

    const membershipData = {
      _id: membership._id,
      name: membership.name,
      startDate: membership.startDate,
      endDate: membership.endDate,
      amount: membership.amount,
      currency: membership.currency,
      description: membership.description,
      membershipListId: membership._id
    };

    if (floatingAdminRef.current) {
      floatingAdminRef.current.close();
    }
    navigate('/membership-checkout', { state: { membershipData } });
  };

  const closeMembershipSelection = () => {
    setMembershipSelectionOpen(false);
  };

  return {
    availableMemberships,
    membershipSelectionOpen,
    loading,
    error,
    fetchAvailableMemberships,
    handleMembershipButtonClick,
    handleMembershipConfirmation,
    closeMembershipSelection
  };
}; 